<template>
  <form-layout :label="label">
    <read-only-input :value="prefectureValue" />
  </form-layout>
</template>

<script>
import {convertPrefectureCodeToName} from '@/constants/prefecture'
import FormLayout from '@/views/templates/FormLayout'
import ReadOnlyInput from "@/views/atoms/inputs/ReadOnlyInput";

export default {
  name: "PrefectureBrowseItem",
  components: {
    FormLayout,
    ReadOnlyInput,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: '都道府県'
    },
    value: {
      type: [Number, null],
      required: true,
    }
  },
  computed: {
    prefectureValue() {
      return convertPrefectureCodeToName(this.value);
    }
  }
}
</script>
